export default "__VITE_ASSET__41adccb7__"